import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUser } from '../../types/user/user';

const initialState: TUser = {
  isAuthenticated: false,
} as TUser;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<TUser>) => {
      return action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUser },
} = userSlice;
